import debounce from 'lodash.debounce'

export const createAvailabilityPickerPanelBinding = ({ debounceMs = 250 } = {}) => {
  let panel = null
  let handler = null
  let onPanelChange = null
  const debouncedPanelChange = debounce(() => onPanelChange?.(), debounceMs)

  const unbind = () => {
    if (panel && handler) panel.removeEventListener('click', handler)
    panel = null
    handler = null
    onPanelChange = null
    debouncedPanelChange.cancel()
  }

  const bind = (pickerComponent, callback) => {
    const nextPanel = pickerComponent?.picker?.$el
    if (!nextPanel || nextPanel === panel) return

    unbind()
    panel = nextPanel
    onPanelChange = callback
    handler = (event) => {
      const target = event.target
      if (!target || typeof target.closest !== 'function') return

      const navigationTarget = target.closest([
        '.el-date-picker__prev-btn',
        '.el-date-picker__next-btn',
        '.el-date-picker__header-label',
        '.el-month-table td',
        '.el-year-table td',
      ].join(', '))
      if (navigationTarget) debouncedPanelChange()
    }
    panel.addEventListener('click', handler)
  }

  return { bind, unbind }
}
